
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgmCoreModule } from '@agm/core';
import { ImageToDataUrlModule } from "ngx-image2dataurl";

//Component
import { MultipleImageUploaderComponent } from './multiple-image-uploader.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ImageToDataUrlModule,
  ],
  declarations: [ MultipleImageUploaderComponent ],
  exports: [ MultipleImageUploaderComponent ]
})

export class MultipleImageUploaderModule { }